import React, { useEffect, useState } from "react";

function ModalNovedadShusi() {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setShowModal(true);
    }, []);

    return (
        <>
            {showModal && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <button style={styles.closeBtn} onClick={() => setShowModal(false)}>
                            ×
                        </button>

                        <img
                            src="/img/shusi-modal.jpg"
                            alt="Novedad Shusi"
                            style={styles.image}
                        />
                    </div>
                </div>
            )}
        </>
    );
}

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "20px",
    },
    modal: {
        position: "relative",
        background: "#fff",
        borderRadius: "12px",
        maxWidth: "500px",
        width: "100%",
        overflow: "hidden",
        boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    },
    closeBtn: {
        position: "absolute",
        top: "10px",
        right: "10px",
        background: "rgba(0,0,0,0.7)",
        color: "#fff",
        border: "none",
        borderRadius: "50%",
        width: "35px",
        height: "35px",
        fontSize: "22px",
        cursor: "pointer",
        zIndex: 2,
    },
    image: {
        width: "100%",
        display: "block",
    },
};

export default ModalNovedadShusi;